import React, { useEffect, useState } from "react";
import "./Pupup.css";
// import { useNavigate } from "react-router-dom";

const WebPopup = ({ navigate }) => {
  const [showModal, setShowModal] = useState(false);
  // const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 4000); // 4 seconds delay

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <>
      {showModal && (
        <div className="webpopup-overlay">
          <div className="webpopup-container">
            <div
              style={{
                marginTop: "-25px",
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "-25px",
                cursor: "pointer",
              }}
            >
              <i
                style={{ color: "#f02936", fontSize: "28px" }}
                class="fa fa-window-close"
                aria-hidden="true"
                onClick={() => setShowModal(false)}
              ></i>
            </div>
            <h2>Subscribe now!</h2>
            <p>
              Get <strong>full access</strong> to our exclusive property
              listings and updates.
            </p>
            <button
              className="webpopup-button"
              onClick={() => {
                navigate("/pricingplan");
                setShowModal(false);
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WebPopup;
